var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRapport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6074 24.2089C21.672 24.2089 22.4023 23.6762 22.7614 23.2115L23.6898 24.0955C23.3804 24.5149 22.39 25.4555 20.5702 25.4555C18.7505 25.4555 17.3393 24.4922 16.8813 22.8489H15.5815L15.7919 21.9989H16.7327C16.7203 21.8855 16.7203 21.7609 16.7203 21.6362C16.7203 21.5115 16.7203 21.3982 16.7327 21.2849H15.5815L15.7919 20.4349H16.8688C17.3269 18.7802 18.7505 17.8169 20.5826 17.8169C22.39 17.8169 23.3804 18.7575 23.6898 19.1882L22.7614 20.0609C22.4023 19.6075 21.6967 19.0635 20.6445 19.0635C19.8027 19.0635 18.9114 19.4715 18.5153 20.4349H21.6224L21.4244 21.2849H18.3172C18.3049 21.3982 18.3049 21.5115 18.3049 21.6362C18.3049 21.7609 18.3049 21.8855 18.3172 21.9989H21.2759L21.0654 22.8489H18.5277C18.9239 23.8009 19.7904 24.2089 20.6074 24.2089Z",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1017 14.5V5C24.1017 2.79086 22.3108 1 20.1017 1H5C2.79086 1 1 2.79086 1 5V22.5C1 24.7091 2.79086 26.5 5 26.5H14.2712",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42371 11H10.8305",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42371 7H18.6949",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.95 21.5C28.95 25.5237 25.3341 28.95 20.661 28.95C15.9879 28.95 12.372 25.5237 12.372 21.5C12.372 17.4763 15.9879 14.05 20.661 14.05C25.3341 14.05 28.95 17.4763 28.95 21.5Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapport);
export default __webpack_public_path__ + "static/media/rapport.e65f66fa5d283a281e3541f351fa1e8c.svg";
export { ForwardRef as ReactComponent };